import { Typography, Button, Grid } from '@mui/material';
import { Container } from '@mui/system';
import { useTranslation } from 'react-i18next';
import React, { Fragment } from 'react';
import { styled } from '@mui/system';
import sadArticle from '../../static/sad-article.png'
import { useNavigate } from 'react-router-dom';

const StyledHomeButton = styled(Button)({
    backgroundColor: '#005691 !important',
    color: '#ffffff',
    fontFamily: 'BoschSans',
    fontSize: '1.25rem',
    textTransform: 'none',
    boxSizing: 'border-box',
    border: '1px solid #005691',
    borderRadius: '0px',
    marginTop: '1rem'
});

const MyDevicesError = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const oopsText = `${(t('ui_spear.support.schedulle_callback_oops_something_missing')).split('!')[0]}...`;
    const lookingForMac = t(
        'ui_spear.devicesError.looking_macbook'
    );
    const issueNearFuture = t(
        'ui_spear.devicesError.issue_near_future'
    )
    const lookingAnotherDevices = t(
        'ui_spear.devicesError.another_devices'
    );

    const goToSupportPage = () => {
        navigate(`/support/ticket`);
    }

    const wait24Hours = () => {
        const splitString = t('ui_spear.devicesError.please_try_24_hours').split('-|');
        const cleanLink = splitString[1].replace('|-', '');
        return (
            <Grid container style={{ marginTop: '17px' }}>
                <Typography>{splitString[0]}</Typography> <a style={{ position: 'relative', top: '-2px', marginLeft: '5px', cursor: 'pointer' }} onClick={() => { goToSupportPage() }}>{cleanLink}</a>
            </Grid>
        )
    }
    const goToHomeLabel = t('ui_spear.devicesError.go_to_devices');

    const goMyDevices = () => {
        navigate('/devices', {
        });
    }
    return (
        <Fragment>
            <Container>
                <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ minHeight: '50vh', minWidth: '125vh' }}
                >
                    <Grid
                        item
                        alt={sadArticle}
                        style={{
                            color: '#999999',
                            fontFamily: 'bosch-icon',
                            marginRight: '2rem',
                            fontSize: '14rem'
                        }}
                    >
                        <img id="info-guy" src={sadArticle} alt="sad-article"></img>
                    </Grid>
                    <Grid item>
                        <Typography className="font-Bosch_sans text-3xl">
                            {oopsText}
                        </Typography>
                        <Grid container>
                            <Grid>
                                <Typography style={{ fontWeight: 'bold', marginRight: '2px' }} className="font-Bosch_sans text-lg mt-4">
                                    {`${lookingForMac}`}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography className="font-Bosch_sans text-lg mt-4">
                                    {`${issueNearFuture}`}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid>
                                <Typography style={{ fontWeight: 'bold', marginRight: '2px' }} className="font-Bosch_sans text-lg mt-4">
                                    {lookingAnotherDevices}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography className="font-Bosch_sans text-lg mt-4">
                                    {wait24Hours()}
                                </Typography>
                            </Grid>
                        </Grid>

                        <StyledHomeButton onClick={() => { goMyDevices() }}>
                            {goToHomeLabel}
                        </StyledHomeButton>
                    </Grid>
                </Grid>
            </Container>
        </Fragment>
    )
}

export default MyDevicesError;